import { useState } from "react";
import { Card, CardContent, Typography, Button, Box, TextField, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { httpClient } from "./dataProvider";

export const LLMImport = () => {
    const [textInput, setTextInput] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async () => {
        setLoading(true);
        setError("");
        try {
            const response = await httpClient(import.meta.env.VITE_SERVER_URL + `/cms/tracks/llm_import`, {
                method: "POST",
                body: JSON.stringify({ text: textInput }),
            });

            const task = response.json;
            let result;

            while (true) {
                result = (
                    await httpClient(
                        import.meta.env.VITE_SERVER_URL + `/cms/tracks/llm_import/${task.task_id}`
                    )
                ).json;
                if (!!result.completed) {
                    break;
                }

                await new Promise((r) => setTimeout(r, 1000));
            }

            // Redirect to track creation with the returned JSON data
            navigate(`/tracks/create?source=${encodeURIComponent(JSON.stringify(result.result))}`);
        } catch (e) {
            setError(`Error: ${e instanceof Error ? e.message : "Failed to process your request"}`);
            setLoading(false);
        }
    };

    return (
        <Card>
            <CardContent>
                <Typography variant="h5" gutterBottom>
                    Import DJ set from a text
                </Typography>
                <Typography variant="body2" color="textSecondary" paragraph>
                    Paste a text below to create a new track.
                </Typography>

                <TextField
                    label="Track description"
                    multiline
                    rows={10}
                    fullWidth
                    variant="outlined"
                    value={textInput}
                    onChange={(e) => {
                        setTextInput(e.target.value);
                        setError("");
                    }}
                    error={!!error}
                    helperText={error}
                    sx={{ mb: 2 }}
                />

                <Box display="flex" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={!textInput.trim() || loading}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : "Create Track"}
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};
